/* eslint-disable indent */
/* eslint-disable comma-dangle */
/* eslint-disable no-trailing-spaces */

type StaticImages = {
    readonly [fileName: string]: {
        uri?: string;
    };
}

const imageStaticSourcesByFileName: StaticImages = {
    'gf1gwCPL8ukgw87u7MtbRH.png': { uri: '/images/gf1gwCPL8ukgw87u7MtbRH.png' },
'k1N7ARzdxHMiZ6iF4J9PAZ.png': { uri: '/images/k1N7ARzdxHMiZ6iF4J9PAZ.png' },
'1PacNV6FB7goxanPBqK8Fr.png': { uri: '/images/1PacNV6FB7goxanPBqK8Fr.png' },
'qh7YRDxamvcvAtqZByeZ2e.png': { uri: '/images/qh7YRDxamvcvAtqZByeZ2e.png' },
'vJVNek4pvdvLitQ6xfxBfe.png': { uri: '/images/vJVNek4pvdvLitQ6xfxBfe.png' },
'qnHVLrB65eahotGcuPJSGK.png': { uri: '/images/qnHVLrB65eahotGcuPJSGK.png' },
'dKJZSEf6cSZi3AjzHwC1Z2.jpg': { uri: '/images/dKJZSEf6cSZi3AjzHwC1Z2.jpg' },
'8xDw1qTF1xcygEGg6Yw9qm.png': { uri: '/images/8xDw1qTF1xcygEGg6Yw9qm.png' },
'iTwL64hgWaJLYHM7YuwVwL.jpg': { uri: '/images/iTwL64hgWaJLYHM7YuwVwL.jpg' },
'jwLjjQo4FxhTog3cFvixqU.png': { uri: '/images/jwLjjQo4FxhTog3cFvixqU.png' },
'1gygD9PGNPyTtmfMbcT974.png': { uri: '/images/1gygD9PGNPyTtmfMbcT974.png' },
'rb4GstmDQwjp3SdWrxdiaF.png': { uri: '/images/rb4GstmDQwjp3SdWrxdiaF.png' },
'1xfaqHkJrAAFh8fCU8zZBv.png': { uri: '/images/1xfaqHkJrAAFh8fCU8zZBv.png' },
'e5kP82cDtcb5wHRzrPEz7o.png': { uri: '/images/e5kP82cDtcb5wHRzrPEz7o.png' },
'dcmbHUNh7zWghSPBzNWfrx.png': { uri: '/images/dcmbHUNh7zWghSPBzNWfrx.png' },
'fS4Wi2x7hFcTocg9LwWGQw.jpg': { uri: '/images/fS4Wi2x7hFcTocg9LwWGQw.jpg' },
'gZuW2ZZhrTzFfB6vnhNYgx.jpg': { uri: '/images/gZuW2ZZhrTzFfB6vnhNYgx.jpg' },
'qHAHyCEnB7q5m5hxboZhdD.png': { uri: '/images/qHAHyCEnB7q5m5hxboZhdD.png' },
'6maqU1Xuu6L7Ns6s7ev4DJ.png': { uri: '/images/6maqU1Xuu6L7Ns6s7ev4DJ.png' },
'mgSLrqrXtTQwaTSQPBYZ7h.png': { uri: '/images/mgSLrqrXtTQwaTSQPBYZ7h.png' },
'6uDH2pBhAw5zsLdFxSMy4n.png': { uri: '/images/6uDH2pBhAw5zsLdFxSMy4n.png' },
'rFU38hmLhd8mFj58Wi7Ron.png': { uri: '/images/rFU38hmLhd8mFj58Wi7Ron.png' },
'bzdvJJmzrWyc7FeMfG6FBG.png': { uri: '/images/bzdvJJmzrWyc7FeMfG6FBG.png' },
'u5JUmyZhKveeUHd5oGqGVj.png': { uri: '/images/u5JUmyZhKveeUHd5oGqGVj.png' },
'g2mHLoDw3u6TDRRURwSSFy.png': { uri: '/images/g2mHLoDw3u6TDRRURwSSFy.png' },
'xz2Kh4AkY5gDz1FUSCF8Ge.png': { uri: '/images/xz2Kh4AkY5gDz1FUSCF8Ge.png' },
'iioLPGkSWJ8mfjefA4ZUXE.png': { uri: '/images/iioLPGkSWJ8mfjefA4ZUXE.png' },
'uNpGhZAxQ1NRMgsbcaf8Hp.png': { uri: '/images/uNpGhZAxQ1NRMgsbcaf8Hp.png' },
'hFZHmAiEpexqJPwkmG5Kvz.png': { uri: '/images/hFZHmAiEpexqJPwkmG5Kvz.png' },
'fEbSV7cXj71RcRtvRUjRrw.png': { uri: '/images/fEbSV7cXj71RcRtvRUjRrw.png' },
'uY9BEtVQeuyjfUBu58EbfY.png': { uri: '/images/uY9BEtVQeuyjfUBu58EbfY.png' },
'7NRzzTog8toT2SWTV2F17X.png': { uri: '/images/7NRzzTog8toT2SWTV2F17X.png' },
'9aQYGU3Cb64f3N4iM5yVYz.png': { uri: '/images/9aQYGU3Cb64f3N4iM5yVYz.png' },
'mMLV42R4Waf1HEunvWa6y8.png': { uri: '/images/mMLV42R4Waf1HEunvWa6y8.png' },
'mPeudswVTmySinpx2HMGHK.jpg': { uri: '/images/mPeudswVTmySinpx2HMGHK.jpg' },
'j8LZqvN7NyxXaTfFAhdQMe.png': { uri: '/images/j8LZqvN7NyxXaTfFAhdQMe.png' },
'16nsJpwxaPziTbEdxasawf.png': { uri: '/images/16nsJpwxaPziTbEdxasawf.png' },
'9bvNEsCThwGorxWRC1m9CD.png': { uri: '/images/9bvNEsCThwGorxWRC1m9CD.png' },
'1kv1CZR7dw4UD2utgzvuzb.png': { uri: '/images/1kv1CZR7dw4UD2utgzvuzb.png' },
'coZSEf8EEqyV1TxWTYMeXz.png': { uri: '/images/coZSEf8EEqyV1TxWTYMeXz.png' },
'bj48pqEJnjSLUPsL2M19iZ.png': { uri: '/images/bj48pqEJnjSLUPsL2M19iZ.png' },
'tMcAYBLS4hXEjfMhPzy1f6.png': { uri: '/images/tMcAYBLS4hXEjfMhPzy1f6.png' },
'r2X32CXpD5MCMhBD6sF1GV.png': { uri: '/images/r2X32CXpD5MCMhBD6sF1GV.png' },
'52Cbwaqq2rNidw9nDNpn4g.png': { uri: '/images/52Cbwaqq2rNidw9nDNpn4g.png' },
'oXVqWEWQH15LHNGx6aqafj.png': { uri: '/images/oXVqWEWQH15LHNGx6aqafj.png' },
'tY7111Hv4uBbumbTSnq63x.png': { uri: '/images/tY7111Hv4uBbumbTSnq63x.png' },
'4KuWk3uomFcbP8VgtKE39d.png': { uri: '/images/4KuWk3uomFcbP8VgtKE39d.png' },
's8yFALBNUhotmsh6tX5sLx.png': { uri: '/images/s8yFALBNUhotmsh6tX5sLx.png' },
'pdKLsuouyieF8pYS4V1x7W.png': { uri: '/images/pdKLsuouyieF8pYS4V1x7W.png' },
'36u8J7zFsxXQseKp5rAkMA.jpg': { uri: '/images/36u8J7zFsxXQseKp5rAkMA.jpg' },
'3xjzot6nneodYfaPmWz64F.png': { uri: '/images/3xjzot6nneodYfaPmWz64F.png' },
'x1s6pQSxhHKSLL55P68Zj2.png': { uri: '/images/x1s6pQSxhHKSLL55P68Zj2.png' },
'mo9NmAKd7HR6d3uB1pQ9Gu.png': { uri: '/images/mo9NmAKd7HR6d3uB1pQ9Gu.png' },
'p86ws55MxLxNAH8ikqyhic.png': { uri: '/images/p86ws55MxLxNAH8ikqyhic.png' },
'jGp4jW9aovN6qi1vqnsNqE.png': { uri: '/images/jGp4jW9aovN6qi1vqnsNqE.png' },
'wU5BbGyTQRCQKheuaHaoqj.png': { uri: '/images/wU5BbGyTQRCQKheuaHaoqj.png' },
'3EBZJm8ajmcF6ZswcYdYgp.png': { uri: '/images/3EBZJm8ajmcF6ZswcYdYgp.png' },
'oLaKVwjiUtGM9bYup6CGHs.png': { uri: '/images/oLaKVwjiUtGM9bYup6CGHs.png' },
'cMubTAHr1qqwCrbBNZSbEs.png': { uri: '/images/cMubTAHr1qqwCrbBNZSbEs.png' },
'duSEfqzmeB8UQnN2WYNGSB.jpg': { uri: '/images/duSEfqzmeB8UQnN2WYNGSB.jpg' },
'8iBWWZs2Q4V6ZJwfxRnXhe.png': { uri: '/images/8iBWWZs2Q4V6ZJwfxRnXhe.png' },
'a8LMFRJNvAdtq4DDxztAuY.png': { uri: '/images/a8LMFRJNvAdtq4DDxztAuY.png' },
'bnkYfHbJiH6QmiC89Cijvs.png': { uri: '/images/bnkYfHbJiH6QmiC89Cijvs.png' },
'whJF2YM6nci1NpBEoekZN2.png': { uri: '/images/whJF2YM6nci1NpBEoekZN2.png' },
'mxLTwfBcjxbZgpKnYH8x2L.png': { uri: '/images/mxLTwfBcjxbZgpKnYH8x2L.png' },
'2bH6Zv8uU84s3ejWSdbBnK.png': { uri: '/images/2bH6Zv8uU84s3ejWSdbBnK.png' },
'mC9qs9SVM4gZHA7rXfLbXp.png': { uri: '/images/mC9qs9SVM4gZHA7rXfLbXp.png' },
'd4Nz1pXxkYMVVa3f9T8mnP.jpg': { uri: '/images/d4Nz1pXxkYMVVa3f9T8mnP.jpg' },
'pDUbecmHm6tZwbSEzhxW96.png': { uri: '/images/pDUbecmHm6tZwbSEzhxW96.png' },
'9sQh6aP8pr6RxtDLpZAUvy.png': { uri: '/images/9sQh6aP8pr6RxtDLpZAUvy.png' },
'daCzcbMjYVfJrFomreSi7u.png': { uri: '/images/daCzcbMjYVfJrFomreSi7u.png' },
'sKLFEi3oiZDV2ZYyjmTPmM.png': { uri: '/images/sKLFEi3oiZDV2ZYyjmTPmM.png' },
'bWcK62c9PhtY55rJiARpK1.png': { uri: '/images/bWcK62c9PhtY55rJiARpK1.png' },
'9EnE3LzarMLn4orvCSMWPg.png': { uri: '/images/9EnE3LzarMLn4orvCSMWPg.png' },
'3TNHKG4bqb3CuMGvXyk4ik.png': { uri: '/images/3TNHKG4bqb3CuMGvXyk4ik.png' },
'3gMzeH6ZoBNWvwh2MZEmBy.png': { uri: '/images/3gMzeH6ZoBNWvwh2MZEmBy.png' },
'cAWV67JVDXsPFeASk8oEok.png': { uri: '/images/cAWV67JVDXsPFeASk8oEok.png' },
'thsPLrofNf7n1JiSFvunpJ.png': { uri: '/images/thsPLrofNf7n1JiSFvunpJ.png' },
'rFwnzGK58QVzVwo4msSSXG.png': { uri: '/images/rFwnzGK58QVzVwo4msSSXG.png' },
'vQETWUo8CYcyhNVh4CrNDH.png': { uri: '/images/vQETWUo8CYcyhNVh4CrNDH.png' },
'3miwzeQhNy37KHGjioMadx.png': { uri: '/images/3miwzeQhNy37KHGjioMadx.png' },
'6XAtHAF3F2ToGscmRRKKN2.png': { uri: '/images/6XAtHAF3F2ToGscmRRKKN2.png' },
'pBbaSNpmmj6GBjnD4VmQUs.png': { uri: '/images/pBbaSNpmmj6GBjnD4VmQUs.png' },
'nPArVXrBATsNKwfnaSAThE.png': { uri: '/images/nPArVXrBATsNKwfnaSAThE.png' },
'rs2nwFuWDyAvvxAYdf9egb.png': { uri: '/images/rs2nwFuWDyAvvxAYdf9egb.png' },
'xv5SJ3bKwrYiZ3GGSFJegF.png': { uri: '/images/xv5SJ3bKwrYiZ3GGSFJegF.png' },
'r2XHEY79eEfauBHB875awN.png': { uri: '/images/r2XHEY79eEfauBHB875awN.png' },
'84oJjBB3FiUTmLuUGHRtxQ.png': { uri: '/images/84oJjBB3FiUTmLuUGHRtxQ.png' },
'tBLk7HRhnQCzhvDFoiQrsx.png': { uri: '/images/tBLk7HRhnQCzhvDFoiQrsx.png' },
'fNMx64SUVQ3bvCfXDkDz8m.png': { uri: '/images/fNMx64SUVQ3bvCfXDkDz8m.png' },
'wKmxN3nYMH6J8vyZTQ4KBE.png': { uri: '/images/wKmxN3nYMH6J8vyZTQ4KBE.png' },
'7FbGQtuJf6kV5vTDeHW4w8.jpg': { uri: '/images/7FbGQtuJf6kV5vTDeHW4w8.jpg' },
'htULGPYUuZy46EWjmNVe84.png': { uri: '/images/htULGPYUuZy46EWjmNVe84.png' },
'eVJoGNn2JYHAJcuwTn1hm1.jpg': { uri: '/images/eVJoGNn2JYHAJcuwTn1hm1.jpg' },
'wrwceHGP14ZwTfzpbcVKLf.png': { uri: '/images/wrwceHGP14ZwTfzpbcVKLf.png' },
'm6fZNj3vB38NC4iGq1aP5y.png': { uri: '/images/m6fZNj3vB38NC4iGq1aP5y.png' },
'pBaJxaCnAkPUFzCbyHj3ft.png': { uri: '/images/pBaJxaCnAkPUFzCbyHj3ft.png' },
'p2EDCDMHG9U9NYf2CM9Ejn.png': { uri: '/images/p2EDCDMHG9U9NYf2CM9Ejn.png' },
'9QYuYsn1wo2LqGhMjR1Ywg.png': { uri: '/images/9QYuYsn1wo2LqGhMjR1Ywg.png' },
'urtTopJCpyD2CuhxPhmtV7.png': { uri: '/images/urtTopJCpyD2CuhxPhmtV7.png' },
'unrLCzEeC2V5v7LdsBNpWf.jpg': { uri: '/images/unrLCzEeC2V5v7LdsBNpWf.jpg' },
'gpJ7efEvuPHPCQtAAcnD3F.png': { uri: '/images/gpJ7efEvuPHPCQtAAcnD3F.png' },
'2QwJMwRUb2eGiGtgY23CNo.png': { uri: '/images/2QwJMwRUb2eGiGtgY23CNo.png' },
'5Dowd5WQkYCCGDAzCfBo7M.png': { uri: '/images/5Dowd5WQkYCCGDAzCfBo7M.png' },
'xi3tepGucZSgeNtM1dvHBm.png': { uri: '/images/xi3tepGucZSgeNtM1dvHBm.png' },
'ay94sqbAj4FJfN4YKY5trM.png': { uri: '/images/ay94sqbAj4FJfN4YKY5trM.png' }
}

export default imageStaticSourcesByFileName
